// @ts-nocheck
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';
import useIssueType from './useIssueType';
import useLocalAttribute from './useLocalAttribute';
import useTemplate from './useTemplate';
import useSection from './useSection';
import useTemplateVersion from './Templates/useTemplateVersion';
import {
  getAllSummarySections,
  createSummarySections,
  deleteSummarySections,
  updateSummarySections,
} from './useSummary';

export default function useEntity() {
  const {
    createIssueType,
    deleteIssueType,
    getAllIssueTypesList,
    updateIssueType,
  } = useIssueType();
  const { addAttribute, deleteAttribute, updateAttribute } =
    useLocalAttribute();
  const {
    checkTemplateForAffectedEntities,
    reorderTemplate,
    deleteTemplate,
    getCustomEntityTemplate,
    getSingleEntity,
    customEntityList,
    createCustomEntity,
    updateCustomEntity,
    entityList,
    setEntityList,
    sectionData,
    setSectionData,
    getSummarySectionsAttributeOrder,
    orderSummarySectionsAttribute,
    getVersionsCommonAttributes,
  } = useTemplate();
  const {
    getTemplateVersionList,
    publishDefaultTemplateVersion,
    updateDefaultTemplateVersion,
    createNewTemplateVersion,
    migrateEntitiesToTemplateVersion,
    compareTemplateVersions,
  } = useTemplateVersion();
  const { createSection, deleteSection } = useSection();

  const getModelsDetailsOfWorkflowTemplate = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_MODEL_DETAILS_OF_WORKFLOW_CHANGES}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const transitionAllModels = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.TRANSITION_ALL_MODELS}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getSectionsDetails = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_SECTIONS_DETAILS}`,
        { params: body }
      )
      .then((res) => {
        setSectionData(res.data);
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const attachWorkflow = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.ATTACH_WORKFLOW}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getWorkflowRoles = (workflowName) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_WORKFLOW_ROLES}`,
        { params: workflowName }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const importTemplate = (payload) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.IMPORT_TEMPLATE}`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const downloadSampleTemplate = () => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.DOWNLOAD_SAMPLE_TEMPLATE}`,
        {
          responseType: 'arraybuffer', // Set responseType to 'arraybuffer' to handle binary data
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const exportTemplate = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.EXPORT_TEMPLATE}`,
        {
          params: body, // Place params here in the config object
          responseType: 'arraybuffer', // Set responseType to 'arraybuffer' to handle binary data
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const importAttribute = (payload) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.IMPORT_ATTRIBUTE}`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const downloadSampleAttribute = () => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.DOWNLOAD_SAMPLE_ATTRIBUTE}`,
        {
          responseType: 'arraybuffer', // Set responseType to 'arraybuffer' to handle binary data
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const exportAttribute = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.EXPORT_ATTRIBUTE}`,
        body,
        {
          responseType: 'arraybuffer', // ensure file download works
        }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  };

  const postModelMangement = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.MODEL_MANAGEMENT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getModelMangement = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.MODEL_MANAGEMENT}`,
        {
          params: body,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateModelMangement = (body) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.MODEL_MANAGEMENT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  //cyclic process of model-management

  const getModelMangementCyclicProcess = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CYCLIC_PROCESS}`,
        {
          params: body,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const postModelMangementCyclicProcess = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CYCLIC_PROCESS}`,
        body
      )
      .then(() => {
        return getModelMangementCyclicProcess({
          from_template_id: body?.from_template_id,
          from_template_version_id: body?.from_template_version_id,
        });
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateModelMangementCyclicProcess = (body) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.CYCLIC_PROCESS}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getArtifactProcessess = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.ARTIFACT_PROCESS}`,
        {
          params: body,
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getArtifactProcessStatus = (body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.ARTIFACT_PROCESS_STATUS}`,
        {
          params: body,
          loader: loader,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getGlobalAttributeReport = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GLOBAL_ATTRIBUTES_REPORT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getLocalAttributeReport = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.LOCAL_ATTRIBUTES_REPORT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getAllAttributeReport = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.GET_ATTRIBUTE_REPORTS}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const downloadAttributeReport = (body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CE.DOWNLOAD_REPORT}`,
        {
          params: body,
          responseType: 'blob',
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const downloadInventoryViewReport = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DOWNLOAD_INVENTORY_VIEW_REPORT}`,
        body,
        {
          responseType: 'blob',
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return {
    customEntityList,
    createCustomEntity,
    getSectionsDetails,
    createSection,
    sectionData,
    setSectionData,
    deleteSection,
    getCustomEntityTemplate,
    addAttribute,
    deleteAttribute,
    attachWorkflow,
    deleteTemplate,
    updateAttribute,
    reorderTemplate,
    entityList,
    setEntityList,
    updateCustomEntity,
    getSingleEntity,
    createIssueType,
    updateIssueType,
    getAllIssueTypesList,
    deleteIssueType,
    getAllSummarySections,
    createSummarySections,
    updateSummarySections,
    deleteSummarySections,
    getModelsDetailsOfWorkflowTemplate,
    transitionAllModels,
    getWorkflowRoles,
    checkTemplateForAffectedEntities,
    importTemplate,
    downloadSampleTemplate,
    exportTemplate,
    getGlobalAttributeReport,
    getLocalAttributeReport,
    downloadAttributeReport,
    downloadInventoryViewReport,
    getAllAttributeReport,
    postModelMangement,
    getModelMangement,
    updateModelMangement,
    getArtifactProcessess,
    getArtifactProcessStatus,
    getSummarySectionsAttributeOrder,
    orderSummarySectionsAttribute,
    updateModelMangementCyclicProcess,
    postModelMangementCyclicProcess,
    getModelMangementCyclicProcess,
    importAttribute,
    downloadSampleAttribute,
    exportAttribute,
    getTemplateVersionList,
    publishDefaultTemplateVersion,
    updateDefaultTemplateVersion,
    createNewTemplateVersion,
    migrateEntitiesToTemplateVersion,
    getVersionsCommonAttributes,
    compareTemplateVersions,
  };
}
